import Stack from '@mui/material/Stack'

import { P, Text } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'

import { NetWorthCopy } from '../../../core'

interface ZeroStateProps {
  copy: NetWorthCopy
}

const ZeroState = ({ copy }: ZeroStateProps) => {
  return (
    <Stack sx={{ flexDirection: 'row', gap: 12 }}>
      <Icon name="elevation" size={32} sx={{ color: 'text.primary' }} />
      <Stack>
        <Text sx={{ display: 'block', fontWeight: 600 }} variant="body1">
          {copy.empty_widget_header}
        </Text>
        <P sx={{ color: 'text.secondary' }} variant="body2">
          {copy.zero_state_description}
        </P>
      </Stack>
    </Stack>
  )
}

export default ZeroState
